import React, { useState, useEffect, useCallback, useRef } from "react";
import { fetchDocumentsByCompany, getFileContentUrl } from "../../../services/documentsService";
import { uploadDocument, deleteDocument } from "../../../services/documentsService";
import { extractKpisFromFile } from "../../../services/documentsService";

import {
  Box,
  Grid,
  Paper,
  Typography,
  IconButton,
  Divider,
  Stack,
  CircularProgress,
  ClickAwayListener,
  Chip,
  TextField,
  InputAdornment,
  Button,
  ButtonGroup,
  Grow,
  MenuList,
  Menu,
  MenuItem,
  Checkbox,
  ListSubheader,
  ListItemIcon,
  ListItemText,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Alert,
  Popper,
  Snackbar,
} from "@mui/material";
import CommonButton from "../../../components/common/CommonButton/CommonButton";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useDropzone } from "react-dropzone";
import DocumentCard from "../../company/tabs/documents/DocumentCard";
/* Icons */
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import AssessmentIcon from "@mui/icons-material/Assessment";
import LinkIcon from "@mui/icons-material/Link";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import OfflineBoltIcon from "@mui/icons-material/OfflineBolt";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DocumentSection from "../../company/tabs/documents/DocumentSection";
import ControlCameraIcon from "@mui/icons-material/ControlCamera";
import { HelpRounded, Info } from "@mui/icons-material";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import AutoAwesomeTwoToneIcon from "@mui/icons-material/AutoAwesomeTwoTone";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SettingsIcon from "@mui/icons-material/Settings";
import { useAuth } from "../../../components/auth/AuthProvider";
import {mapActivityRequestStatusCodeToLabel, isPartnerActivityReportReadOnly} from "../../../services/activityReportService";


// Grade options for StatCard are A
const GRADE_OPTIONS = [
  "A",
  "A-",
  "A+",
  "B",
  "B-",
  "B+",
  "C",
  "C-",
  "C+",
  "D",
  "D-",
  "F",
  null,
];

const CURRENCIES = [
  { value: "USD", label: "USD — $", symbol: "$" },
  { value: "ILS", label: "ILS — ₪", symbol: "₪" },
  { value: "INR", label: "INR — ₹", symbol: "₹" },
  { value: "GBP", label: "GBP — £", symbol: "£" },
  { value: "THB", label: "THB — ฿", symbol: "฿" },
  { value: "CNY", label: "CNY — ¥", symbol: "¥" },
  { value: "JPY", label: "JPY — ¥", symbol: "¥" },
];
const InfoRow = ({ label, value }) => (
  <Box mb={1.5} display="flex" flexDirection="row" alignItems="center">
    <Typography
      fontSize={12}
      fontWeight={500}
      color="#6B7280"
      sx={{ minWidth: 120 }}
    >
      {label}
    </Typography>
    <Typography
      fontSize={12}
      fontWeight={600}
      color="#111827"
      textAlign="left"
      sx={{ ml: 2, flex: 1 }}
    >
      {value || "—"}
    </Typography>
  </Box>
);

const InfoRow2 = ({ label, value }) => (
  <Box mb={1.5} display="flex" flexDirection="row" alignItems="center">
    <Typography
      fontSize={12}
      fontWeight={500}
      color="#6B7280"
      sx={{ minWidth: 120 }}
    >
      {label}
    </Typography>
    <LinkIcon sx={{ color: "#005786", ml: 1 }} />
    <Typography
      fontSize={12}
      fontWeight={600}
      color="#111827"
      textAlign="left"
      sx={{
        ml: 1,
        flex: 1,
        minWidth: 0,
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        lineHeight: 1.5,
      }}
    >
      {value || "—"}
    </Typography>
  </Box>
);

const EditableStatCard = ({ label, value, control, name, isEditable }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);


  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const handleValueChange = (newValue) => {
    setCurrentValue(newValue);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        height: "100%",
      }}
    >
      <Box display="flex" alignItems="center" gap={2} className="jake">
        <Typography fontSize={14} color="#6B7280" mt={0.5}>
          {label}
          <HelpRoundedIcon
            sx={{
              width: 16,
              height: 16,
              borderRadius: "5px",
              p: 0.4,
              position: "relative",
              top: "7px",
            }}
          />
        </Typography>

        <EditIcon
          onClick={handleEditClick}
          sx={{
            cursor: "pointer",
            color: isEditing ? "#3B82F6" : "#9CA3AF",
            transition: "color 0.2s",
            "&:hover": {
              color: "#3B82F6"
            }
          }}
        />
      </Box>

      {isEditable && isEditing ? (
        <Controller
          name={name}
          control={control}
          defaultValue={currentValue}
          render={({ field }) => (
            <FormControl fullWidth size="small" sx={{ mt: 1 }}>
              <Select
                {...field}
                displayEmpty
                value={currentValue}
                onChange={(e) => {
                  field.onChange(e);
                  handleValueChange(e.target.value);
                }}
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  borderRadius: "20px",
                  fontFamily: "Inter, serif",
                  "& .MuiSelect-select": {
                    py: 0.5,
                  },
                }}
              >
                {GRADE_OPTIONS.map((grade) => (
                  <MenuItem key={grade} value={grade}>
                    <Typography
                      fontSize={14}
                      fontWeight={500}
                      fontFamily="Inter, serif"
                    >
                      {grade}
                    </Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      ) : (
        <Typography
          fontSize={24}
          fontWeight={700}
          color="#111827"
          sx={{ fontFamily: "serif" }}
        >
          {currentValue}
        </Typography>
      )}
    </Paper>
  );
};

// Dropzone component for file uploads
const FileDropzone = ({ onDrop, acceptedFiles, onRemove, isUploading }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".gif"],
      "application/pdf": [".pdf"],
      "application/vnd.ms-powerpoint": [".ppt", ".pptx"],
      "application/msword": [".doc", ".docx"],
      "application/vnd.ms-excel": [".xls", ".xlsx"],
    },
    maxSize: 10485760, // 10MB
    disabled: isUploading,
  });

  // Don't show dropzone if there are files and we're not uploading
  if (acceptedFiles.length > 0 && !isUploading) {
    return null;
  }

  return (
    <Box>
      <Paper
        {...getRootProps()}
        elevation={0}
        sx={{
          p: 3,
          border: "2px dashed",
          borderColor: isDragActive ? "primary.main" : "#E5E7EB",
          borderRadius: "12px",
          bgcolor: isDragActive ? "action.hover" : "#FAFAFA",
          cursor: isUploading ? "not-allowed" : "pointer",
          opacity: isUploading ? 0.5 : 1,
          transition: "all 0.2s ease",
          textAlign: "center",
          mb: 2,
        }}
      >
        <input {...getInputProps()} />
        <CloudUploadIcon sx={{ fontSize: 40, color: "#9CA3AF", mb: 1 }} />
        <Typography variant="body2" color="textSecondary">
          {isDragActive
            ? "Drop the files here..."
            : "Drag & drop files here, or click to select"}
        </Typography>
        <Typography
          variant="caption"
          color="textSecondary"
          display="block"
          sx={{ mt: 1 }}
        >
          Supported: Images, PDF, PowerPoint, Word, Excel (Max 10MB)
        </Typography>
      </Paper>


    </Box>
  );
};

// New component for uploaded files with progress
const UploadedFileItem = ({ file, onDelete, onView, uploadProgress }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
        bgcolor: "#FFFFFF",
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: "#005786",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box display="flex" alignItems="center" gap={2}>
        {/* File Icon */}
        {/* <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "8px",
            bgcolor: "#F3F4F6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AttachFileIcon sx={{ color: "#6B7280", fontSize: 20 }} />
        </Box> */}

        {/* File Info */}
        <Box flex={1}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={0.5}
          >
            <Typography variant="body2" fontWeight={600} color="#111827" pr={6}>
              {file.name}
            </Typography>
            <Box display="flex" alignItems="center" gap={1}>
              {uploadProgress === 100 ? (
                <>
                  <Button
                    size="small"
                    variant="contained"
                    color="secondary"
                    onClick={() => onView(file)}
                    sx={{
                      minWidth: "auto",
                      fontSize: "0.75rem",
                      color: "#1A1919",
                      "&:hover": {
                        backgroundColor: "transparent",
                        textDecoration: "underline",
                      },
                    }}
                  >
                    View
                  </Button>
                  <IconButton
                    size="small"
                    onClick={() => onDelete(file)}
                    sx={{
                      color: "#1A1919",
                      "&:hover": {
                        backgroundColor: "rgba(239, 68, 68, 0.04)",
                      },
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </>
              ) : (
                <Typography variant="caption" color="#6B7280">
                  {Math.round(uploadProgress)}%
                </Typography>
              )}
            </Box>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="caption" color="#6B7280">
              {(file.size / 1024).toFixed(2)} KB
            </Typography>
            {file.lastModified && (
              <>
                <Typography variant="caption" color="#6B7280">
                  •
                </Typography>
                <Typography variant="caption" color="#6B7280">
                  {new Date(file.lastModified).toLocaleDateString()}
                </Typography>
              </>
            )}
          </Box>

          {/* Progress Bar */}
          {uploadProgress < 100 && (
            <Box sx={{ mt: 1, width: "100%" }}>
              <Box
                sx={{
                  height: 4,
                  bgcolor: "#E5E7EB",
                  borderRadius: 2,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${uploadProgress}%`,
                    height: "100%",
                    bgcolor: "#005786",
                    borderRadius: 2,
                    transition: "width 0.3s ease",
                  }}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

const StatCard = ({ label, value }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      border: "1px solid #E5E7EB",
      borderRadius: "12px",
      backgroundColor: "#FFFFFF",
      height: "100%",
    }}
  >
    <Typography fontSize={14} color="#6B7280" mt={0.5}>
      {label}
      <HelpRoundedIcon
        sx={{
          width: 16,
          height: 16,
          borderRadius: "5px",
          p: 0.4,
          position: "relative",
          top: "7px",
        }}
      />
    </Typography>

    <Typography
      fontSize={24}
      fontWeight={700}
      color="#111827"
      sx={{ fontFamily: "serif" }}
    >
      {value}
    </Typography>
  </Paper>
);

// Editable KPI Row Component
const EditableKPIRow = ({ kpi, index, control, role, readonly = false }) => {

  const isCurrency =
    !["Runway", "Total Headcount"].includes(kpi.kpiTitle);

  const isRunway = kpi.kpiTitle === "Runway";

  const commonFieldSx = {
    "& .MuiOutlinedInput-root": {
      height: 42,
      borderRadius: "10px",
      background: "#fff",
      fontSize: 14,
    },

    "& input": {
      padding: "10px 12px",
      fontWeight: 500,
    },
  };

  const renderAdornment = () => {
    if (isRunway) {
      return {
        endAdornment: (
          <InputAdornment position="end">
            month
          </InputAdornment>
        ),
      };
    }

    if (isCurrency) {
      return {
        startAdornment: (
          <InputAdornment position="start">
            $
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            M
          </InputAdornment>
        ),
      };
    }

    return {};
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "220px 1fr 1fr",
        gap: 2,
        alignItems: "center",
        mb: 2,
      }}
    >
      {/* KPI NAME */}
      <Typography
        fontSize={14}
        fontWeight={500}
        color="#374151"
      >
        {kpi.kpiTitle}
      </Typography>

      {/* LAST PERIOD */}
      <Controller
        name={`kpis.${index}.lastPeriod`}
        control={control}
        defaultValue={kpi.lastPeriod}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            disabled
            variant="outlined"
            type="text"
            sx={{
              ...commonFieldSx,
              "& .MuiOutlinedInput-root": {
                ...commonFieldSx["& .MuiOutlinedInput-root"],
                background: "#F9FAFB",
              },
            }}
            InputProps={renderAdornment()}
          />
        )}
      />

      {/* CURRENT PERIOD */}
      <Controller
        name={`kpis.${index}.recentPeriod`}
        control={control}
        defaultValue={kpi.recentPeriod}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            disabled={role === "operations" || readonly}
            variant="outlined"
            type="text"
            sx={commonFieldSx}
            InputProps={renderAdornment()}
          />
        )}
      />
    </Box>
  );
};

// Example setup for a Split Button
const options = ["Action 1", "Action 2", "Action 3"];

const categoriesData = {
  Category1: ["Option A", "Option B", "Option C"],
  Category2: ["Option X", "Option Y", "Option Z"],
};

const mapNumericRequestTypeToLabel = (requestType) => {
  if (requestType === 1) return "Monthly";
  if (requestType === 2) return "Quarterly";
  if (requestType === 3) return "Annual";
  if (requestType === 4) return "Custom";
  return "";
};

// const mapActivityRequestStatusCodeToLabel = (status) => {
//   if (status === 0) return "Overdue";
//   if (status === 1) return "Completed";
//   if (status === 2) return "Submitted";
//   if (status === 3) return "New Request";
//   if (status === 4) return "Draft";
//   if (status === 5) return "Scheduled";
//   return "Unknown Status";
// };

async function fetchGradeReportsReturnState(requestId, prevState, role = 'operations') {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4200/api";
  const [companiesRes, requestDataRes] = await Promise.all([
    fetch(`${API_BASE_URL}/activity-reports/requests/${requestId}/companies`),
    fetch(`${API_BASE_URL}/activity-reports/requests/${requestId}`),
  ]);
  if (!companiesRes.ok || !requestDataRes.ok) {
    throw new Error("Request or companies fetch failed");
  }
  const companiesJson = await companiesRes.json();
  const requestDataJson = await requestDataRes.json();
  const item = requestDataJson?.data ?? requestDataJson;
  if (!item || typeof item !== "object") {
    throw new Error("Unexpected request payload");
  }

  const requestTypeLabel =
    mapNumericRequestTypeToLabel(item.request_type) ||
    (typeof prevState?.request_type === "string" ? prevState.request_type : "");

  const reportName = item.report_name ?? prevState?.reportName ?? "";
  const statusType =
    typeof item.status === "number"
      ? mapActivityRequestStatusCodeToLabel(item.status, role)
      : item.status || prevState?.statusType || "Unknown Status";

  const prevSettings =
    prevState?.settingsData && typeof prevState.settingsData === "object" ? prevState.settingsData : {};
  const settingsData = {
    ...prevSettings,
    ...item,
    due_date: item.due_date ?? prevSettings.due_date,
    report_name: item.report_name ?? prevSettings.report_name ?? reportName,
    request_type: item.request_type ?? prevSettings.request_type,
  };

  return {
    ...prevState,
    requestId,
    reportName,
    statusType,
    requestStatusCode: item.status,
    request_type: requestTypeLabel,
    settingsData,
    companiesData: companiesJson.data ?? prevState?.companiesData ?? [],
    reportData: item.request_data ?? prevState?.reportData ?? null,
    reviewMode: true,
    fromReviewSave: true,
  };
}

const ReviewReport = () => {
  const { user, role } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { companyId } = useParams();
  // Add ref for file input
  const fileInputRef = useRef(null);

  // State management
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadingFiles, setUploadingFiles] = useState([]); // New state for files being uploaded
  const [uploadProgress, setUploadProgress] = useState({}); // Track progress per file
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  // State to hold the DOM element that the menu will anchor to
  const [anchorEl, setAnchorEl] = useState(null);
  // State to manage selected options: { Category1: ['Option A'], Category2: [] }
  const [selected, setSelected] = useState(
    Object.keys(categoriesData).reduce(
      (acc, cat) => ({ ...acc, [cat]: [] }),
      {},
    ),
  );
  const [reportingCurrency, setReportingCurrency] = useState("USD");
  const [documentsData, setDocumentsData] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [extractingKpi, setExtractingKpi] = useState(false);
  const [uploadedDocumentList, setUploadedDocumentList] = useState([]);
  const [recentPeriodLabel, setRecentPeriodLabel] = useState("Current Extracted Period");
  const [lastPeriodLabel, setLastPeriodLabel] = useState("Last Period");
  const [lastCompletedMetrics, setLastCompletedMetrics] = useState(null);
  const [currentRecordMetrics, setCurrentRecordMetrics] = useState(null);


  // State to control the visibility of the menu (true if open, false if closed)
  const open = Boolean(anchorEl);
  // Dynamic parameters from Navigation state or defaults
  const dynamicPartner = location.state?.partner_doc;
  const dynamicKpi = location.state?.kpi || "CARR";

  // ADD these (matching Overview exactly):
  const dynamicPartner_name = location.state?.partner_name;

  const dynamicArId = location.state?.ar_id;
  useEffect(() => {
    const fetchCurrentRecord = async () => {
      try {
        if (!dynamicArId || !location.state?.requestId) return;
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4200/api";

        // ✅ Use the existing records endpoint
        const res = await fetch(
          `${API_BASE_URL}/activity-reports/records?request_id=${location.state.requestId}&partner_name=${encodeURIComponent(dynamicPartner_name)}&partner_doc_name=${encodeURIComponent(partnerCode)}`
        );
        const result = await res.json();

        console.log("CURRENT RECORD RESPONSE:", result);

        if (result?.data && Array.isArray(result.data)) {
          // ✅ Find the specific record by ar_id
          const record = result.data.find(r => r.id === dynamicArId);

          if (!record) {
            setCurrentRecordMetrics(null);
            return;
          }
          if (record) setCurrentRecordMetrics(record);
        }
      } catch (err) {
        console.error("Failed to fetch current record", err);
      }
    };
    fetchCurrentRecord();
  }, [dynamicArId]);


  const statusType = location.state?.statusType || "Unknown Status";

  const requestStatusCode =
    typeof location.state?.requestStatusCode === "number"
      ? location.state.requestStatusCode
      : typeof location.state?.settingsData?.status === "number"
        ? location.state.settingsData.status
        : null;
  const partnerReadOnly = isPartnerActivityReportReadOnly(role, requestStatusCode, statusType);

  const partnerCode = location.state?.partner_doc ? String(location.state.partner_doc) : "";
  const dealId = location.state?.deal_id ? String(location.state.deal_id) : "";

  // Handle file drop with simulated upload progress


  const onDrop = useCallback(async (acceptedFiles) => {
    for (const file of acceptedFiles) {
      try {
        setExtractingKpi(true);

        // show uploaded file immediately
        setUploadedDocumentList((prev) => [...prev, file]);

        const result = await extractKpisFromFile(file);

        console.log("KPI RESPONSE:", result);

        if (result?.kpis) {
          applyParsedKpis(result.kpis);

          // dynamic title
          const detectedPeriod =
            result?.kpis?.arr?.period ||
            result?.kpis?.rev_run_rate?.period ||
            "Latest Extracted";

          setRecentPeriodLabel(detectedPeriod);
        }

        setSnackbar({
          open: true,
          message: "KPI extracted successfully",
          severity: "success",
        });

      } catch (err) {
        console.error(err);

        setSnackbar({
          open: true,
          message: err.message || "Failed to extract KPI",
          severity: "error",
        });
      } finally {
        setExtractingKpi(false);
      }
    }
  }, []);
  const applyParsedKpis = (kpisFromApi) => {

  const mapKey = (title) => {
    const mapping = {
      "Revenue": "revenue",
      "Cash Balance": "cash_balance",
      "Runway": "runway",
      "Net Income": "net_income",
      "Total Headcount": "total_head_count",
      "ARR": "arr",
    };

    return mapping[title] || title.toLowerCase().replace(/\s+/g, "_");
  };

  // KPI fields expected in millions
  const millionFields = [
    "revenue",
    "cash_balance",
    "net_income",
    "arr",
    "rev_run_rate",
  ];

  const updated = kpisData.map((kpi) => {

    const apiKey = mapKey(kpi.kpiTitle);

    let apiValue = kpisFromApi?.[apiKey]?.value;
let apiUnit = kpisFromApi?.[apiKey]?.unit || "";

// Revenue fallback
if (
  (apiValue === null || apiValue === undefined) &&
  apiKey === "revenue"
) {
  apiValue =
    kpisFromApi?.arr?.value ??
    kpisFromApi?.rev_run_rate?.value;

  apiUnit =
    kpisFromApi?.arr?.unit ??
    kpisFromApi?.rev_run_rate?.unit ??
    "";
}

// ARR fallback
if (
  (apiValue === null || apiValue === undefined) &&
  apiKey === "arr"
) {
  apiValue = kpisFromApi?.rev_run_rate?.value;

  apiUnit = kpisFromApi?.rev_run_rate?.unit || "";
}

    // -----------------------------
    // FIX STARTS HERE
    // -----------------------------
    if (typeof apiValue === "number") {

      const unit = apiUnit;

      let normalizedValue = apiValue;

      // Convert raw USD -> millions only when needed
      if (
        millionFields.includes(apiKey) &&
        unit.toLowerCase().includes("usd") &&
        !unit.toLowerCase().includes("million")
      ) {
        normalizedValue = apiValue / 1000000;
      }

      return {
        ...kpi,
        recentPeriod: formatKpiValue(normalizedValue),
      };
    }

    return {
  ...kpi,
  recentPeriod:
    kpi.recentPeriod ||
    currentRecordMetrics?.[apiKey] ||
    "",
};
  });

  reset({ kpis: updated });
};

  // Handle file view
  const handleViewFile = (doc) => {
    const url = getFileContentUrl(doc.path);
    window.open(url, "_blank");
  };

  // Handle file delete
  const handleDeleteFile = (fileToDelete) => {
    setUploadedFiles((prev) =>
      prev.filter((file) => file.name !== fileToDelete.name),
    );
    setSnackbar({
      open: true,
      message: "File removed successfully",
      severity: "info",
    });
  };

  // Handle file selection from button click
  const handleFileSelect = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length > 0) {
      onDrop(selectedFiles);
    }
    // Clear the input value so the same file can be selected again
    event.target.value = "";
  };

  // Handle upload button click
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };



  // Check if grade should be editable
  const isGradeEditable = !partnerReadOnly && [
    "Pending",
    "In Progress",
    "Pending Completion",
    "Scheduled",
    "New Request",
  ].includes(statusType);

  const handleMainAction = () => {
    console.log("Main button clicked");
  };

  const handleSecondaryAction = (event) => {
    console.log("Right side (icon) clicked");
    setAnchorEl(event.currentTarget);
  };

  // Function to close the menu
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCategorySelectAll = (category, options) => {
    // If all are already selected, deselect all; otherwise select all.
    if (selected[category].length === options.length) {
      setSelected((prev) => ({ ...prev, [category]: [] }));
    } else {
      setSelected((prev) => ({ ...prev, [category]: [...options] }));
    }
  };

  const handleOptionToggle = (category, option) => {
    const selectedOptions = selected[category];
    const newSelected = selectedOptions.includes(option)
      ? selectedOptions.filter((item) => item !== option)
      : [...selectedOptions, option];

    setSelected((prev) => ({ ...prev, [category]: newSelected }));
  };

  const formatKpiValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    const num = Number(value);

    if (Number.isNaN(num)) return "";

    return num.toFixed(2);
  };
  const parseMetricValue = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return 0;
  }

  const parsed = parseFloat(value);

  return isNaN(parsed) ? 0 : parsed;
};


  const kpisData = React.useMemo(() => [
  {
    kpiTitle: "Revenue",
    lastPeriod: parseMetricValue(lastCompletedMetrics?.revenue).toFixed(2),
    recentPeriod:
      currentRecordMetrics?.revenue != null
        ? formatKpiValue(currentRecordMetrics.revenue)
        : "",
  },
  {
    kpiTitle: "Cash Balance",
    lastPeriod: parseMetricValue(lastCompletedMetrics?.cash_balance).toFixed(2),
    recentPeriod:
      currentRecordMetrics?.cash_balance != null
        ? formatKpiValue(currentRecordMetrics.cash_balance)
        : "",
  },
  {
    kpiTitle: "Runway",
    lastPeriod: parseMetricValue(lastCompletedMetrics?.runway).toFixed(0),
    recentPeriod:
      currentRecordMetrics?.runway != null
        ? formatKpiValue(currentRecordMetrics.runway)
        : "",
  },
  {
    kpiTitle: "Net Income",
    lastPeriod: parseMetricValue(lastCompletedMetrics?.net_income).toFixed(2),
    recentPeriod:
      currentRecordMetrics?.net_income != null
        ? formatKpiValue(currentRecordMetrics.net_income)
        : "",
  },
  {
    kpiTitle: "Total Headcount",
    lastPeriod: parseMetricValue(lastCompletedMetrics?.total_head_count).toFixed(0),
    recentPeriod:
      currentRecordMetrics?.total_head_count != null
        ? formatKpiValue(currentRecordMetrics.total_head_count)
        : "",
  },
  {
    kpiTitle: "ARR",
    lastPeriod: parseMetricValue(
      lastCompletedMetrics?.top_line_kpi
    ).toFixed(2),
    recentPeriod:
      currentRecordMetrics?.top_line_kpi != null
        ? formatKpiValue(currentRecordMetrics.top_line_kpi)
        : "",
  },
], [lastCompletedMetrics, currentRecordMetrics]);

  // Initialize React Hook Form
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      grade: apiData?.Grade || "A",
      kpis: kpisData,
      uploadedFiles: [],
    },
  });

  // Watch form values for preview
  const watchedGrade = watch("grade");
  const watchedKpis = watch("kpis");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // ✅ Use companyName from state, NOT the URL param (which is the UUID)
        const companyName = location.state?.companyName || decodeURIComponent(companyId);
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4200/api";

        // ✅ Same URL structure as Overview
        const url = `${API_BASE_URL}/portfolio/overview?dealId=${dealId}&partnerCode=${dynamicPartner}&partnerName=${dynamicPartner_name}&company=${companyName}&kpi=${dynamicKpi}`;

        const response = await fetch(url);
        const result = await response.json();

        if (result.status === "success" && result.data) {
          const raw = result.data;

          // ✅ Normalize field names to match what the UI expects
          setApiData({
            company_name: raw.Company || raw.company_name,
            Partner: raw.partner || raw.Partner,
            company_sector: raw.company_sector,
            company_city: raw.company_city,
            cashout_date: raw.cashout_date || raw.cashout,
            website: raw.website,
            description: raw.company_description || raw.description,
            Grade: raw.grade || raw.Grade,  // ✅ normalize grade casing
            fund_family: raw.fund_family,                                    // ✅ ADD
            invested_capital: raw.invested_capital_in_million_usd            // ✅ ADD
              ? `$${raw.invested_capital_in_million_usd.toFixed(1)}M`
              : null,
          });
        } else {
          setApiData(null);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        // keep your fallback jakeData here if needed
      } finally {
        setLoading(false);
      }
    };

    if (companyId) fetchData();
  }, [companyId, dynamicPartner, dynamicPartner_name, dynamicKpi, dealId]);

  useEffect(() => {
    const fetchLastCompletedMetrics = async () => {
      try {
        if (!dynamicPartner_name || !companyId) return;

        const API_BASE_URL =
          process.env.REACT_APP_API_BASE_URL ||
          "http://localhost:4200/api";
        // ✅ Use companyName from state, same as fetchData
        const companyName = location.state?.companyName || decodeURIComponent(companyId);

        const response = await fetch(
          `${API_BASE_URL}/activity-reports/last-completed-metrics?partner_name=${encodeURIComponent(dynamicPartner_name)}&company_name=${encodeURIComponent(companyName)}`
        );

        const result = await response.json();

        console.log("LAST COMPLETED KPI:", result);

        if (result?.data) {
          // ✅ Use activity_report, not data directly
          const metrics = result.data.activity_report;
          setLastCompletedMetrics(metrics);

          // Optional dynamic period label
          if (result?.data?.period_end_date) {
            const formattedDate = new Date(
              result.data.period_end_date
            ).toLocaleDateString("en-US", {
              month: "long",
              year: "numeric",
            });

            setLastPeriodLabel(`Last Period (${formattedDate})`);
          }
        }
      } catch (err) {
        console.error("Failed to fetch last completed metrics", err);
      }
    };

    fetchLastCompletedMetrics();
  }, [dynamicPartner_name, companyId]);
  useEffect(() => {
    reset({
      grade: apiData?.Grade || "A",
      kpis: kpisData,
      uploadedFiles: [],
    });
  }, [lastCompletedMetrics, currentRecordMetrics]);
  const loadDocuments = async () => {
    try {
      if (!partnerCode || !dealId) return;

      setDocumentsLoading(true);
      const res = await fetchDocumentsByCompany(partnerCode, dealId);
      setDocumentsData(res?.sections || []);
    } catch (err) {
      console.error(err);
      setDocumentsData([]);
    } finally {
      setDocumentsLoading(false);
    }
  };

  useEffect(() => {


    loadDocuments();
  }, [partnerCode, dealId]);
  // ✅ ADD THIS EXACTLY HERE (after above useEffect, before any return)
  useEffect(() => {
    if (!apiData && !loading) {
      console.warn("Using mock data for KPI testing");

      setApiData({
        company_name: "Test Company",
        Partner: "Test Partner",
        company_sector: "Tech",
        company_city: "NY",
        cashout_date: "-",
        website: "test.com",
        description: "Testing KPI extraction",
        Grade: "A"
      });
    }
  }, [apiData, loading]);
  // Handle file removal
  const handleRemoveFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  // Handle form submission
  const persistReviewRecord = async (data) => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4200/api";
    const res = await fetch(`${API_BASE_URL}/activity-reports/records`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: dynamicArId,
        request_id: location.state?.requestId,
        grade: data.grade ?? null,
        revenue: data.kpis?.find((k) => k.kpiTitle === "Revenue")?.recentPeriod ?? null,
        cash_balance: data.kpis?.find((k) => k.kpiTitle === "Cash Balance")?.recentPeriod ?? null,
        runway: data.kpis?.find((k) => k.kpiTitle === "Runway")?.recentPeriod ?? null,
        net_income: data.kpis?.find((k) => k.kpiTitle === "Net Income")?.recentPeriod ?? null,
        total_head_count: data.kpis?.find((k) => k.kpiTitle === "Total Headcount")?.recentPeriod ?? null,
        top_line_kpi: data.kpis?.find((k) => k.kpiTitle === "ARR")?.recentPeriod ?? null,
      }),
    });
    if (!res.ok) throw new Error("Failed to save review");
    return res;
  };

  /** Non-operations: persist and return to the request companies list with header + due date state. */
  const onSave = async (data) => {
    try {
      await persistReviewRecord(data);
      const requestId = location.state?.requestId;
      let navState = {
        ...location.state,
        requestId,
        reviewMode: true,
        fromReviewSave: true, // flag to indicate we just saved from review
      };
      if (requestId) {
        try {
          navState = await fetchGradeReportsReturnState(requestId, location.state, role);
        } catch (err) {
          console.error("Failed to enrich navigation state for grade-reports", err);
        }
      }
      setSnackbar({ open: true, message: "Saved successfully.", severity: "success" });
      setTimeout(() => {
        if (requestId) {
          navigate(`/grade-reports/${requestId}`, {
            replace: true,
            state: navState,
          });
        } else {
          navigate("/grade-reports", { replace: true, state: navState });
        }
      }, 1500);
    } catch {
      setSnackbar({ open: true, message: "Error saving form", severity: "error" });
    }
  };

  // Handle cancel edit
  const handleCancel = () => {
    reset();
    setUploadedFiles([]);
    setIsEditing(false);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={10}>
        <CircularProgress />
      </Box>
    );
  }

  /* if (!apiData) {
    return (
      <Box p={4}>
        <Typography>
          No data found for "{companyId}" with Partner "{dynamicPartner}".
        </Typography>
      </Box>
    );
  } */


  return (
    <Box sx={{ p: 4, backgroundColor: "#FFFFFF", minHeight: "100vh" }}>
      {/* Header with Edit/Save buttons */}
      {/* <Box sx={{ maxWidth: 1600, margin: "0 auto", mb: 3, display: "flex", justifyContent: "flex-end" }}>
        {!isEditing ? (
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={() => setIsEditing(true)}
            sx={{ borderColor: "#E5E7EB", color: "#374151" }}
          >
            Edit Review
          </Button>
        ) : (
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={handleSubmit(onSubmit)}
              sx={{ bgcolor: "#005786", "&:hover": { bgcolor: "#004570" } }}
            >
              Save Changes
            </Button>
            <Button
              variant="outlined"
              startIcon={<CancelIcon />}
              onClick={handleCancel}
              sx={{ borderColor: "#E5E7EB", color: "#374151" }}
            >
              Cancel
            </Button>
          </Stack>
        )}
      </Box> */}

      <Grid container spacing={3} sx={{ maxWidth: 1600, margin: "0 auto" }}>
        {/* LEFT COLUMN */}
        <Grid item xs={3} md={3} sx={{ width: "30%" }}>
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              border: "1px solid #E5E7EB",
              borderRadius: "12px",
              mb: 2,
            }}
          >
            <InfoRow label="Company" value={apiData?.company_name} />
            <InfoRow label="Partner" value={apiData?.Partner} />
            <InfoRow label="Sector" value={apiData?.company_sector} />
            <InfoRow label="Location" value={apiData?.company_city} />
            {/* <InfoRow label="1st Investment Day" value="Jan 15, 2021" /> */}
            <InfoRow label="Fund Family" value={apiData?.fund_family} />
            <InfoRow label="Inv. Cap" value={apiData?.invested_capital} />
            {/* <InfoRow label="Cash Out Date" value={apiData?.cashout_date} /> */}
            <InfoRow2 label="Website" value={apiData?.website} />
            <InfoRow label="Description" value={apiData?.description} />
          </Paper>

          <Stack spacing={2}>
            <EditableStatCard
              label="Grade"
              value={apiData?.Grade}
              control={control}
              name="grade"
              isEditable={isGradeEditable && role !== "operations"} // ✅ ops can't edit grade
            />
          </Stack>
        </Grid>

        {/* RIGHT COLUMN */}
        <Grid item xs={9} md={9} sx={{ width: "66%" }}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              border: "1px solid #E5E7EB",
              borderRadius: "12px",
              mb: 2,
              bgcolor: "#FAFAFA",
            }}
          >
            {/* HEADER */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography fontSize={14} fontWeight={700}>
                Documents
              </Typography>

              <Button
                variant="contained"
                size="small"
                startIcon={<CloudUploadIcon />}
                onClick={handleUploadClick}
                sx={{
                  borderRadius: "20px",
                  textTransform: "none",
                  fontSize: 13,
                  bgcolor: "#005786",
                  "&:hover": { bgcolor: "#004570" },
                }}
              >
                Upload
              </Button>
            </Box>

            {/* Hidden input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileSelect}
              multiple
              style={{ display: "none" }}
            />

            {/* FILE LIST */}
            {documentsLoading ? (
              <Box display="flex" justifyContent="center" py={3}>
                <CircularProgress size={24} />
              </Box>
            ) : uploadedDocumentList.length === 0 &&
              documentsData.length === 0 ? (
              <Typography fontSize={12} color="#6B7280">
                No documents uploaded yet
              </Typography>
            ) : (
              <Grid container spacing={2}>

                {/* LOCAL UPLOADED FILES */}
                {uploadedDocumentList.map((file, i) => (
                  <Grid item xs={6} key={`local-${i}`}>
                    <Paper
                      sx={{
                        p: 2,
                        borderRadius: "12px",
                        border: "1px solid #E5E7EB",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      {extractingKpi && (
                        <Box
                          sx={{
                            position: "absolute",
                            inset: 0,
                            bgcolor: "rgba(255,255,255,0.75)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 10,
                            flexDirection: "column",
                            gap: 1,
                          }}
                        >
                          <CircularProgress size={22} />
                          <Typography fontSize={11}>
                            Extracting KPI...
                          </Typography>
                        </Box>
                      )}

                      <Typography fontSize={13} fontWeight={600}>
                        {file.name}
                      </Typography>

                      <Typography fontSize={11} color="#6B7280" mt={1}>
                        {(file.size / 1024).toFixed(1)} KB
                      </Typography>

                      <Chip
                        label="Parsed"
                        size="small"
                        color="success"
                        sx={{ mt: 1 }}
                      />
                    </Paper>
                  </Grid>
                ))}

                {/* SERVER DOCUMENTS */}
                {documentsData.flatMap((section) =>
                  section.documents.map((doc, i) => (
                    <Grid item xs={6} key={i}>
                      <Paper
                        sx={{
                          p: 2,
                          borderRadius: "12px",
                          border: "1px solid #E5E7EB",
                        }}
                      >
                        <Typography fontSize={13} fontWeight={600}>
                          {doc.name}
                        </Typography>

                        <Box display="flex" gap={1} mt={1}>
                          <Button
                            size="small"
                            onClick={() =>
                              window.open(getFileContentUrl(doc.path), "_blank")
                            }
                          >
                            View
                          </Button>

                          <Button
                            size="small"
                            color="error"
                            onClick={async () => {
                              await deleteDocument(doc.path);
                              await loadDocuments();
                            }}
                          >
                            Delete
                          </Button>
                        </Box>
                      </Paper>
                    </Grid>
                  ))
                )}
              </Grid>
            )}
          </Paper>

          {/* KPI's Verifying Section - Editable when isEditing is true */}
          <Paper
            elevation={0}
            sx={{
              p: 3,
              border: "1px solid #E5E7EB",
              borderRadius: "12px",
              bgcolor: "#FAFAFA",
            }}
          >
            <Box display="flex" alignItems="center" justifyContent="space-between" gap={1} mb={3}>
              <Box display="flex" alignItems="center" gap={1}>
                <AssessmentIcon sx={{ width: 16, height: 16, color: "#CABFAD", borderRadius: "5px", p: 0.4 }} />
                <Typography fontSize={14} fontWeight={700}>KPI's Verifying</Typography>
              </Box>

              <Box display="flex" alignItems="center" gap={1}>
                <Typography fontSize={12} color="#6B7280" fontWeight={500} noWrap>
                  Reporting currency
                </Typography>
                <Select
                  value={reportingCurrency}
                  onChange={(e) => setReportingCurrency(e.target.value)}
                  size="small"
                  sx={{
                    fontSize: 12,
                    fontWeight: 600,
                    borderRadius: "20px",
                    "& .MuiSelect-select": { py: 0.5, px: 1.5 },
                    "& fieldset": { borderColor: "#E5E7EB" },
                  }}
                >
                  {CURRENCIES.map((c) => (
                    <MenuItem key={c.value} value={c.value}>
                      <Typography fontSize={12} fontWeight={600}>{c.label}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "220px 1fr 1fr",
                gap: 2,
                mb: 3,
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={13}
                fontWeight={700}
                color="#111827"
              >
                KPI
              </Typography>

              <Box>
                <Chip
                  label={lastPeriodLabel}
                  size="small"
                />
              </Box>

              <Box>
                <Chip
                  label={extractingKpi ? "Extracting..." : recentPeriodLabel}
                  size="small"
                  color={extractingKpi ? "warning" : "default"}
                />
              </Box>
            </Box>

            {watch("kpis")?.map((kpi, idx) => (
              <EditableKPIRow
                key={kpi.kpiTitle + idx}
                kpi={kpi}
                index={idx}
                control={control}
                role={role}  // ✅ pass role down
                readonly={partnerReadOnly}
              />
            ))}
          </Paper>

          {[
            "Pending",
            "In Progress",
            "Pending Completion",
            "Scheduled",
            "New Request",
          ].includes(statusType) && (
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  border: "1px solid #E5E7EB",
                  borderRadius: "12px",
                  bgcolor: "#FAFAFA",
                  mt: 2,
                }}
              >
                <Box display="flex" alignItems="center" gap={1} mb={3}>
                  <OfflineBoltIcon
                    sx={{
                      width: 16,
                      height: 16,
                      color: "#CABFAD",
                      borderRadius: "5px",
                      p: 0.4,
                    }}
                  />
                  <div>
                    <Typography fontSize={14} fontWeight={700}>
                      Company News
                    </Typography>
                  </div>
                </Box>

                <Box display="flex" mb={2}>
                  <Typography fontSize={12} color="#757677" sx={{ width: "54%" }}>
                    Latest Update, 12 June 2025
                  </Typography>
                  <Typography fontSize={12} color="#757677">
                    Write important news or notes
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" gap={2} mb={2}>
                  <Typography
                    fontWeight={500}
                    fontSize={12}
                    color="#6B7280"
                    sx={{
                      width: "50%",
                      border: "solid 1px #E0E3E5",
                      padding: "15px",
                      borderRadius: "12px",
                      color: "#111827",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    The company's focus on enterprise features, including advanced
                    security and workflow automation, is paying dividends.
                    International revenue now represents 32% of total revenue, up
                    from 28% last year.
                  </Typography>
                  <TextField
                    multiline
                    rows={11}
                    defaultValue="Your comment..."
                    fontWeight={500}
                    sx={{
                      width: "50%",
                      height: "222px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        fontSize: 12,
                        color: "#757677",
                      },
                    }}
                  />
                </Box>

                <ButtonGroup
                  variant="contained"
                  size="small"
                  color="secondary"
                  aria-label="split button"
                  sx={{
                    position: "relative",
                    float: "right",
                    bottom: "60px",
                    right: "8px",
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                  }}
                >
                  {/* Primary Action */}
                  {/* <Button onClick={handleMainAction}>
                    <ListItemIcon>
                      <AutoAwesomeTwoToneIcon />
                    </ListItemIcon>
                    Generate
                  </Button> */}

                  {/* Secondary Action on the Right */}
                  {/* <Button
                    size="small"
                    aria-label="Select sources"
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    variant="contained"
                    onClick={handleSecondaryAction}
                  >
                    <SettingsIcon />
                  </Button> */}
                  
                </ButtonGroup>

                <Menu
                  id="checkbox-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "checkbox-menu-button",
                  }}
                >
                  {Object.entries(categoriesData).map(([category, options]) => (
                    <React.Fragment key={category}>
                      {/* Using ListSubheader for category titles */}
                      <ListSubheader disableSticky sx={{ pointerEvents: "none" }}>
                        {category}
                      </ListSubheader>

                      {/* Select All for the category */}
                      <MenuItem
                        onClick={() => handleCategorySelectAll(category, options)}
                      >
                        <ListItemIcon>
                          <Checkbox
                            // Indeterminate state if some but not all options are selected
                            indeterminate={
                              selected[category].length > 0 &&
                              selected[category].length < options.length
                            }
                            checked={selected[category].length === options.length}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>

                      {/* Individual options */}
                      {options.map((option) => (
                        <MenuItem
                          key={option}
                          onClick={() => handleOptionToggle(category, option)}
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={selected[category].includes(option)}
                            />
                          </ListItemIcon>
                          <ListItemText primary={option} />
                        </MenuItem>
                      ))}
                    </React.Fragment>
                  ))}
                </Menu>
                {/* Display selected values for verification */}
                {/* <pre>{JSON.stringify(selected, null, 2)}</pre> */}
              </Paper>
            )}

          {["Complete", "Completed", "Submitted"].includes(statusType) && (
            <Paper
              elevation={0}
              sx={{
                p: 3,
                border: "1px solid #E5E7EB",
                borderRadius: "12px",
                bgcolor: "#FAFAFA",
                mt: 2,
              }}
            >
              <Box display="flex" alignItems="center" gap={1} mb={3}>
                <OfflineBoltIcon
                  sx={{
                    width: 16,
                    height: 16,
                    color: "#CABFAD",
                    borderRadius: "5px",
                    p: 0.4,
                  }}
                />
                <div>
                  <Typography fontSize={14} fontWeight={700}>
                    Company News
                  </Typography>
                </div>
              </Box>
              <div>
                <Typography fontSize={12} color="#6B7280">
                  The company's focus on enterprise features, including advanced
                  security and workflow automation, is paying dividends.
                  International revenue now represents 32% of total revenue, up
                  from 28% last year.
                </Typography>
              </div>
            </Paper>
          )}
        </Grid>
      </Grid>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {/* Submit Button — only visible for non-ops */}
      {role !== "operations" && !partnerReadOnly && (
        <Box sx={{ maxWidth: 1600, margin: "0 auto", mt: 3, display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            size="large"
            onClick={handleSubmit(onSave)}
            sx={{
              bgcolor: "#005786",
              borderRadius: "20px",
              textTransform: "none",
              fontWeight: 600,
              px: 4,
              "&:hover": { bgcolor: "#004570" },
            }}
          >
            Save
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ReviewReport;
